import { render, staticRenderFns } from "./FormInduction.vue?vue&type=template&id=83c6c2e2&lang=pug&"
import script from "./FormInduction.vue?vue&type=script&lang=js&"
export * from "./FormInduction.vue?vue&type=script&lang=js&"
import style0 from "./FormInduction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports